import React from "react";
import "./Shipping.css";

const PAYMENT_METHODS = [
  {
    icon: "pi pi-building-columns",
    title: "Transferencia",
    desc: "SPEI / transferencia bancaria. Envía tu comprobante y confirmamos en minutos.",
  },
  {
    icon: "pi pi-wallet",
    title: "Efectivo",
    desc: "Pago en mano al momento de la entrega personal.",
  },
];

const SHIPPING_OPTIONS = [
  {
    icon: "pi pi-inbox",
    carrier: "Correos de México",
    detail: "Desde $70 MXN",
    note: "Tarifa base para paquetes estándar. El costo final puede variar según peso y dimensiones.",
  },
  {
    icon: "pi pi-truck",
    carrier: "Otras paqueterías",
    detail: "A cotizar",
    note: "FedEx, DHL, Estafeta u otras. Solicita tu cotización antes de confirmar tu pedido.",
  },
];

const DELIVERY_POINTS = [
  {
    icon: "pi pi-map-marker",
    place: "Plaza del Sol",
    detail: "Guadalajara, Jalisco — punto de encuentro principal.",
  },
  {
    icon: "pi pi-train",
    place: "Linea 1 Tren ligero",
    detail: "Desde la estacion Periferico Sur hasta la estacion Juarez.",
  },
  {
    icon: "pi pi-compass",
    place: "Punto intermedio",
    detail: "A acordar entre ambas partes según ubicación.",
  },
];

const LAYAWAY_STEPS = [
  {
    number: "01",
    title: "Aparta con el 20%",
    desc: "Para reservar tu figura basta con el 20% del valor del producto. Elige el plazo que mejor te acomode.",
  },
  {
    number: "02",
    title: "Pagos flexibles",
    desc: "Liquida en el tiempo y las parcialidades que mejor te acomoden.",
  },
  {
    number: "03",
    title: "Recibe tu figura",
    desc: "El envío o la entrega se realiza al completar el pago total.",
  },
];

export default function Envios() {
  return (
    <div className="envios-page">

      {/* ── Hero ── */}
      <header className="envios-hero">
        <div className="envios-hero__inner">
          <span className="envios-hero__eyebrow">Angelvarius Shop</span>
          <h1 className="envios-hero__title">Envíos &amp; Pagos</h1>
          <p className="envios-hero__sub">
            Todo lo que necesitas saber para recibir tus figuras de forma segura.
          </p>
        </div>
        <div className="envios-hero__deco" aria-hidden="true">
          <span className="envios-hero__deco-ring envios-hero__deco-ring--1" />
          <span className="envios-hero__deco-ring envios-hero__deco-ring--2" />
        </div>
      </header>

      <main className="envios-content">

        {/* ── Métodos de pago ── */}
        <section className="envios-section">
          <div className="envios-section__head">
            <span className="envios-section__tag">01</span>
            <h2 className="envios-section__title">Métodos de pago</h2>
          </div>
          <div className="envios-cards envios-cards--2">
            {PAYMENT_METHODS.map((m) => (
              <div className="envios-card" key={m.title}>
                <div className="envios-card__icon-wrap">
                  <i className={m.icon} />
                </div>
                <h3 className="envios-card__name">{m.title}</h3>
                <p className="envios-card__desc">{m.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── Envíos ── */}
        <section className="envios-section">
          <div className="envios-section__head">
            <span className="envios-section__tag">02</span>
            <h2 className="envios-section__title">Envíos a domicilio</h2>
          </div>
          <div className="envios-cards envios-cards--2">
            {SHIPPING_OPTIONS.map((s) => (
              <div className="envios-card" key={s.carrier}>
                <div className="envios-card__icon-wrap">
                  <i className={s.icon} />
                </div>
                <h3 className="envios-card__name">{s.carrier}</h3>
                <span className="envios-card__badge">{s.detail}</span>
                <p className="envios-card__desc">{s.note}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── Entregas personales ── */}
        <section className="envios-section">
          <div className="envios-section__head">
            <span className="envios-section__tag">03</span>
            <h2 className="envios-section__title">Entregas personales</h2>
          </div>
          <p className="envios-section__intro">
            Si estás en Guadalajara podemos coordinar una entrega en mano, sin costo de envío.
          </p>
          <div className="envios-cards envios-cards--2">
            {DELIVERY_POINTS.map((d) => (
              <div className="envios-card envios-card--flat" key={d.place}>
                <i className={`${d.icon} envios-card__flat-icon`} />
                <div>
                  <h3 className="envios-card__name">{d.place}</h3>
                  <p className="envios-card__desc">{d.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ── Apartados ── */}
        <section className="envios-section envios-section--accent">
          <div className="envios-section__head">
            <span className="envios-section__tag envios-section__tag--light">04</span>
            <h2 className="envios-section__title envios-section__title--light">Sistema de apartados</h2>
          </div>
          <p className="envios-section__intro envios-section__intro--light">
            ¿No quieres perder una figura pero aún no tienes el monto completo? Con los apartados
            puedes asegurarla desde hoy.
          </p>
          <div className="envios-steps">
            {LAYAWAY_STEPS.map((step) => (
              <div className="envios-step" key={step.number}>
                <span className="envios-step__number">{step.number}</span>
                <div className="envios-step__body">
                  <h3 className="envios-step__title">{step.title}</h3>
                  <p className="envios-step__desc">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

      </main>
    </div>
  );
}
